module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "file_013"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('strong', [_vm._v("THE FORMATION OF GRUMMAN AIRCRAFT ENGINEERING CORPORATION")])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("They could have blamed Edgar Gott, the president of Keystone Aircraft Corporation, for their misfortune. Keystone had, however indirectly, taken their jobs. Swirbul and Grumman had recently been part of the senior staff at the Loening Aeronautical Engineering Company, based in New York City. Until, that is, Grover Loening was forced to sell to Keystone and the companies merged in 1929.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grumman and Swirbul had come to work at Loening’s aircraft factory in an unusual way. The pair had been in the military: Grumman was a navy pilot, and Swirbul served in the Marine Corps and then became a civilian inspector for the Army Air Corps. They had been sent to the Loening company to oversee the production of military floatplanes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grover Loening and his brother Albert knew talented aviation men when they saw them. The Loenings soon devised ways to have Swirbul and Grumman work for them instead of with them. By the time the business came apart in 1929, Grumman was Loening’s general manager and Swirbul worked as the factory manager.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Loening workforce fragmented when Keystone announced that Loening’s Manhattan factory would be closed. The jobs were moving seventy-five miles south, to Bristol, Pennsylvania. Grumman, Swirbul, and some others didn’t want to leave New York. They hatched an idea to create their own aircraft company. And it had been rough going ever since.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In December 1929, they scraped together $81,325. Grumman was the voting stockholder with the most shares, and the new company became Grumman Aircraft Engineering Corporation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Grumman name was painted on a large sign outside a building on Railroad Avenue in Baldwin, New York. It was an uphill battle from the start. When they first moved into the place, the windows had been shattered and the skylights were caved in. Drifts of dead oak leaves covered the floor.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b78c16d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_013.vue
// module id = 90
// module chunks = 0